import { useState, useContext } from "react";
import "./Modal.css";
import { HarvestContext } from "../store/HarvestContext";

export type AddProductModalBodyProps = {
  onClose: () => void;
};

const validationMessage =
  "You need to add name, quantity and price to be able to add your item.";

const duplicateMessage =
  "It looks like you already have this product in your inventory.";

export function AddProductModalBody({ onClose }: AddProductModalBodyProps) {
  const { createHarvestProduct, harvestProducts } = useContext(HarvestContext);
  const [newItem, setNewItem] = useState("");
  const [quantity, setQuantity] = useState(0);
  const [price, setPrice] = useState<number>(0);
  const [formError, setFormError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const discount = null;

  async function addProductAndCloseModal() {
    if (isSubmitting) return;
    setFormError(null);

    const existingItem = harvestProducts.find((product) => {
      return product.name.trim().toLowerCase() === newItem.trim().toLowerCase();
    });

    if (existingItem) {
      setFormError(duplicateMessage);
      return;
    }
    if (newItem === "" || quantity === 0 || price === 0) {
      setFormError(validationMessage);
      return;
    }

    setIsSubmitting(true);
    try {
      await createHarvestProduct(newItem, quantity, price, discount);
      onClose();
      setNewItem("");
      setQuantity(0);
      setPrice(0);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="harvest-input-wrapper">
      <div className="modal-content-wrapper">
        <div className="harvest-input">
          <label htmlFor="harvest-product">New harvest product</label>

          <input
            type="text"
            name="harvestProduct"
            id="harvest-product"
            required
            placeholder="Product name"
            onChange={(e) => {
              setNewItem(e.currentTarget.value);
              setFormError(null);
            }}
          />
        </div>
        <div className="harvest-input">
          <label htmlFor="harvest-product-quantity">Quantity in kilos</label>

          <input
            type="number"
            name="harvestProductQuantity"
            id="harvest-product-quantity"
            placeholder="0"
            min={0}
            onChange={(e) => {
              setQuantity(parseFloat(e.currentTarget.value) || 0);
              setFormError(null);
            }}
          />
        </div>
        <div className="harvest-input">
          <label htmlFor="harvest-product-price">Price per kilo</label>

          <input
            type="number"
            name="harvestProductPrice"
            id="harvest-product-price"
            placeholder="0"
            min={0}
            onChange={(e) => {
              setPrice(parseFloat(e.currentTarget.value) || 0);
              setFormError(null);
            }}
          />
        </div>
        {formError && (
          <p className="pickup-form-validation-msg" role="alert">
            {formError}
          </p>
        )}
      </div>
      <div className="buttons-footer">
        <button
          className="btn harvest-add-btn"
          type="button"
          disabled={isSubmitting}
          onClick={() => void addProductAndCloseModal()}
        >
          {isSubmitting ? "Adding..." : "Add"}
        </button>
      </div>
    </div>
  );
}
